import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { showWidgetQueryParam } from './Cart/Constants';

const Cart = dynamic(() => import('./Cart'), {
  ssr: false,
});

export default function CartOverlayContainer(props) {
  const { setAddedToCart, offerList, setCloseCart, setIsCartOpen } = props;
  const [showCartOverlay, setShowCartOverlay] = useState(false);
  const [showForgroundCart, setShowForgroundCart] = useState(false);
  const closeTimeoutRef = useRef(null);
  const router = useRouter();
  const smoothCloseSideSheet = () => {
    setShowForgroundCart(false);
    closeTimeoutRef.current = setTimeout(() => {
      if (closeTimeoutRef.current) {
        setShowCartOverlay(false);
      }
    }, 420);
  };
  useEffect(() => {
    if (
      router.query.hasOwnProperty(showWidgetQueryParam) ||
      router.query.hasOwnProperty('diaperSizePopup') ||
      router.query.hasOwnProperty('diaperSizeB2G1Popup')
    ) {
      clearTimeout(closeTimeoutRef.current);

      setShowCartOverlay(() => true);

      setShowForgroundCart(true);
      if (setIsCartOpen) {
        setIsCartOpen(true);
      }
      closeTimeoutRef.current = null;
    } else {
      smoothCloseSideSheet();
    }
  }, [router.query]);

  return showCartOverlay ? (
    <Cart
      showForgroundCart={showForgroundCart}
      setAddedToCart={setAddedToCart}
      smoothCloseSideSheet={smoothCloseSideSheet}
      offerListData={offerList}
      setCloseCart={setCloseCart}
      setIsCartOpen={setIsCartOpen}
    />
  ) : null;
}
